// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".technical-specs-info .row[data-v-b57c9298]{flex-direction:row-reverse}.technical-specs-info .organism-technical-specs[data-v-b57c9298]{height:100%;left:0;overflow:hidden;position:absolute;top:0;width:100%;z-index:5}.technical-specs-info .info-mobile[data-v-b57c9298]{overflow-y:auto}@media only screen and (max-width:767px){.technical-specs-info .info-mobile[data-v-b57c9298]{display:block;margin:10px 0 20px;max-height:295px!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
